import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { GenerateReportForm } from 'features/yieldbirdWrapperAgent/forms/GenerateReportForm'

import type { GenerateReportFormProps } from 'features/yieldbirdWrapperAgent/forms/GenerateReportForm'

export const GenerateReportSection = (props: GenerateReportFormProps): React.JSX.Element => {
  const { t } = useTranslation('features/yieldbirdWrapperAgent', { keyPrefix: 'generate' })

  return (
    <Paper>
      <SectionHeader
        subtitle={t('subtitle')}
        title={t('title')}
      />

      <GapBox />

      <GenerateReportForm {...props} />
    </Paper>
  )
}
